import {
  EDIT_NEW_PASSWORD, EDIT_RE_NEW_PASSWORD, RESET_CONFIRM_PASSWORD_FORM,
  REQUEST_CONFIRM_PASSWORD, REQUEST_CONFIRM_PASSWORD_SUCCESS,
  REQUEST_CONFIRM_PASSWORD_FAILED
} from "../actions/password_reset_confirm_form_actions";

const initialState = {
  new_password: '',
  re_new_password: '',
  requestProgress: false,
  requestFailed: false,
}

export const passwordResetConfirmReducer = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_NEW_PASSWORD: {
      return {
        ...state,
        new_password: action.new_password
      }
    }
    case EDIT_RE_NEW_PASSWORD: {
      return {
        ...state,
        re_new_password: action.re_new_password
      }
    }
    case RESET_CONFIRM_PASSWORD_FORM: {
      return {
        ...state,
        new_password: '',
        re_new_password: '',
      }
    }
    case REQUEST_CONFIRM_PASSWORD: {
      return {
        ...state,
        requestProgress: true,
        requestFailed: false
      }
    }
    case REQUEST_CONFIRM_PASSWORD_SUCCESS: {
      return {
        ...state,
        new_password: '',
        re_new_password: '',
        requestProgress: false,
        requestFailed: false
      }
    }
    case REQUEST_CONFIRM_PASSWORD_FAILED: {
      return {
        ...state,
        requestProgress: false,
        requestFailed: true
      }
    }
    default: return state;
  }
}
